import { apiDatesAdapters } from '@sequencehq/utils/dates'
import { Quote } from 'modules/Cube/domain/cube.domain.types'

type OriginalPhase = NonNullable<
  Quote['amendment']
>['original']['phases'][number]

/**
 * The phase of the schedule an amendment was made from that runs on the given
 * day. A phase with no end date runs on for good.
 */
export const getOriginalPhaseRunningOn = ({
  original,
  date
}: {
  original: NonNullable<Quote['amendment']>['original']
  date: Date
}): OriginalPhase | undefined => {
  const day = apiDatesAdapters.toApi(date)

  return original.phases.find(
    phase => phase.startDate <= day && (!phase.endDate || day <= phase.endDate)
  )
}
